const errorCode = (response, returnedComponent) => {
  if (response?.status == 400) {
    return {
      message: response.errorMessage,
      uiMessage: "something went wrong",
      returnedComponent,
      status: response?.status,
    };
  } else if (response?.status == 401) {
    return {
      message: response.errorMessage,
      uiMessage: "you are not authorized",
      returnedComponent,
      status: response?.status,
    };
  } else if (response?.status == 403) {
    return {
      message: response.errorMessage,
      uiMessage: "Page Not accessible",
      returnedComponent,
      status: response?.status,
    };
  } else if (response?.status == 404) {
    return {
      message: response.errorMessage,
      uiMessage: "Page Not Found",
      returnedComponent,
      status: response?.status,
    };
  } else if (response?.status >= 500 && response?.status <= 599) {
    return {
      message: response.errorMessage,
      uiMessage: "Server Error",
      returnedComponent,
      status: response?.status,
    };
  } else {
    return {
      message: response.errorMessage,
      uiMessage: "Something Went Wrong",
      returnedComponent,
      status: response?.status,
    };
  }
};

export default errorCode;

//   if (apiType == "auth") {
//     if (response.status == 400) {
//       return {
//         message: response.errorMessage,
//         uiMessage: "something went wrong",
//         returnedComponent,
//       };
//     } else {
//       return {
//         message: response.message,
//         uiMessage: "Server Error",
//         returnedComponent,
//       };
//     }
//   } else {
// }
